<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            :link="require('@/assets/img/pc/curv_19_a.jpg')"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Das ikonische Produktdesign des portablen Soundsystems CURV 500® interpretiert den klassischen Line Array neu und erschließt somit - sowohl ästhetisch als auch funktional - neue Kontexte. CURV 500® wurde als kompaktes Line Array mit professionellen Konfigurationsmöglichkeiten für unterschiedliche Anwendungsszenarien gestaltet. Das portable Lautsprecherset, mit integriertem Mischer, zeichnet sich durch eine kabellose Plug and Play‘ Steckverbindung der Satelliten aus. Das Design des leichten Subwoovers überzeugt mit einem ergonomischen Tragekomfort und einer Formensprache, die Leichtigkeit sowie Benutzerfreundlichkeit kommuniziert.</p>

        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                :link="require('@/assets/img/pc/curv_17_a.jpg')"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                :link="require('@/assets/img/pc/curv_15_a.jpg')"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            :link="require('@/assets/img/pc/curv_16_a.jpg')"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                :link="require('@/assets/img/pc/curv_14_b.jpg')"
                aspect-ratio="23/12"
                class="w-full px-4"
            ></tailwind-image>
            <div class="w-full px-4 flex flex-col justify-center">
                <tailwind-image
                    :link="require('@/assets/img/pc/curv_18_b.jpg')"
                    aspect-ratio="16/12"
                    class="w-full"
                ></tailwind-image>
            </div>
        </div>
        <tailwind-image
            :link="require('@/assets/img/pc/curv_19_a.jpg')"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            :link="require('@/assets/img/pc/curv_20_a.jpg')"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            :link="require('@/assets/img/pc/curv_21_a.jpg')"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Markus Holzbach mit Spacekitchen</p>
        </span>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {};
    },
    methods: {},
    created () { },
};
</script>